import React from 'react';


const Section1 = ()=>{

    return(

        <div className="section1">
            <div className="row stayConnected">
                <div className="col-xs-12 col-sm-12 col-md-12 col-lg-5 col-xl-5 col-wrap order-2 order-lg-1 order-xl-1">
                    <div className="imageContainer">
                        <img src="./images/logo.png" alt="" />
                    </div>
                </div>
                <div className="col-xs-12 col-sm-12 col-md-12 col-lg-7 col-xl-7 col-wrap order-1 order-lg-1 order-xl-1">
                    <div className="content">
                        <h1>
                            Stay Connected
                        </h1>
                        <p>
                            Stay Connected! As your one-stop shop for all things related to LUMS, we are committed to fostering your engagement with your alma mater and ensuring your participation in alumni activities. Whether it’s organizing more reunions around the world, hosting more mentorship sessions on campus, or promoting alumni success stories, we cannot move forward without you. Our alumni community is just as much a part of the LUMS story today than it ever has been before, and we are determined to facilitate your access to the University’s networks, resources, and events.
                        </p>
                        <p>
                        In this effort, we’d like to do our best to stay in touch with you the right way and keep you updated with all that is happening at LUMS. So how can you help us? Update your information in our alumni database! All you have to do is access your profile in the database, view your details, and make any necessary changes. Authenticating even as little as your basic contact information can help us go a long way in staying connected.
                        </p>
                     </div>
                </div>
            </div>
            <div className="row alumniAwards">
                <div className="col-12 content">
                    <h3>
                        Alumni Achievement Awards
                    </h3>
                    <p>
                        LUMS is pleased to announce the Vice Chancellor's Alumni Achievement Awards (VC-AAA) which will recognize outstanding alumni for their exemplary accomplishments across sectors, including contributions made and services rendered in communities locally and around the world, with a commitment that reflects the LUMS spirit. Awardees will be selected through a comprehensive nomination and evaluation process by the Awards Committee and up to 10 alumni will be awarded in a given year.
                    </p>
                </div>
                <div className="col-12">
                    <div className="row awardPics">
                        <div className="col-xs-12 col-sm-6 col-md-6 col-lg-3 col-xl-3 col-wrap">
                            <div className="img-container">
                                <img src="./images/home/award1.jpg" className="shadow" alt="" />
                            </div>
                        </div>
                        <div className="col-xs-12 col-sm-6 col-md-6 col-lg-3 col-xl-3 col-wrap">
                             <div className="img-container">
                                <img src="./images/home/award2.jpg" className="shadow" alt="" />
                            </div>
                        </div>
                        <div className="col-xs-12 col-sm-6 col-md-6 col-lg-3 col-xl-3 col-wrap">
                            <div className="img-container">
                                <img src="./images/home/award3.jpg" className="shadow" alt="" />
                            </div>
                        </div>
                        <div className="col-xs-12 col-sm-6 col-md-6 col-lg-3 col-xl-3 col-wrap">
                            <div className="img-container">
                                <img src="./images/home/award4.jpg" className="shadow" alt="" />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-12">
                    <div className="row awardText">
                        <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 link">
                           
                                <a href="/">
                                    Pride of Lums <i className="fa fa-caret-right"></i>
                                </a>
                           
                        </div>
                        <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 link">
                           
                                <a href="/">
                                    Celebrating Luminites <i className="fa fa-caret-right"></i>
                                </a>
                           
                        </div>
                    </div>
                </div>
            </div>
            <div className="row annualReunion">
                <div className="col-xs-12 col-sm-12 col-md-12 col-lg-6 col-xl-6 col-wrap order-2 order-lg-1 order-xl-1">
                    <div className="imageContainer">
                        <img src="./images/home/annualReunion.jpeg" alt="" />
                    </div>
                </div>
                <div className="col-xs-12 col-sm-12 col-md-12 col-lg-6 col-xl-6 col-wrap order-1 order-lg-1 order-xl-1">
                    <div className="content">
                        <h1>
                            Annual Reunion
                        </h1>
                        <h3>
                            ( Up Coming Event )
                        </h3>
                        <a href="/" className="btn btn-primary btn-lg btn-register">Register Now</a>
                     </div>
                </div>
            </div>
        </div>

    );

}

export default React.memo(Section1);